const userColumnData = [
  {
    Header: 'Id',
    accessor: 'id'
  },
  {
    Header: 'First Name',
    accessor: 'firstName'
  },
  {
    Header: 'Last Name',
    accessor: 'lastName'
  },
  {
    Header: 'Email',
    accessor: 'email'
  },
  {
    Header: 'Role',
    accessor: 'role'
  },
  {
    Header: 'Created At',
    accessor: 'createdAt'
  },
  {
    Header: 'Updated At',
    accessor: 'updatedAt'
  }
];
export default userColumnData;
